import Link from "next/link";
import { useState } from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import {
  FlexBetween,
  FlexBox,
} from "src/lib/components/salify-next-layout/default/components/flex-box";

import { CartButtonWithSwipeableDrawer } from "src/lib/components/header/default";
import Typography from "@mui/material/Typography"; // ==============================================================
import Drawer from "@mui/material/Drawer";
import IconDefault from "../../icon/default";
import { Paragraph } from "../../salify-next-layout/default/components/Typography";
import Image from "next/image";
import SalifyFallback from "src/lib/components/salify-fallback/default";
import SearchInput from "./search-input";
import { toAssetImages } from "src/lib/utils";

// ==============================================================
const MobileHeader = (props) => {
  const [searchBarOpen, setSearchBarOpen] = useState(false);
  const toggleSearchBar = () => setSearchBarOpen((state) => !state);

  const ICON_STYLE = {
    color: "grey.600",
    fontSize: 20,
  };
  const QUICK_ACTION_SX = {
    width: 42,
    height: 42,
    borderRadius: 2,
    bgcolor: "#DCE8D4",
    p: 0,
  };
  return (
    <>
      <FlexBetween
        width="100%"
        sx={{
          pl: "max(8px, env(safe-area-inset-left))",
          pr: "max(12px, env(safe-area-inset-right))",
          gap: 1,
        }}
      >
        <Link
          href="/"
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            minWidth: 0,
            flex: "1 1 auto",
            overflow: "hidden",
          }}
        >
          {props.logoUrl && (
            <Image
              src={toAssetImages(props.logoUrl)}
              alt="me"
              width={props.logoWidth ?? 50}
              height={props.logoHeight ?? 50}
            />
          )}
          <Typography
            variant="h4"
            component="h1"
            fontWeight="700"
            noWrap
            sx={{ minWidth: 0, textOverflow: "ellipsis", overflow: "hidden" }}
          >
            {props.name}
          </Typography>
        </Link>

        <FlexBox
          justifyContent="end"
          alignItems="center"
          flex="0 0 auto"
          gap={0.75}
          sx={{ mr: 0.5, ml: 1, py: 0.5, mt: 0.5 }}
        >
          <IconButton
            sx={{ ...QUICK_ACTION_SX, bgcolor: "#F3F5F9" }}
            onClick={toggleSearchBar}
            aria-label="Tìm kiếm"
          >
            <IconDefault sx={ICON_STYLE} icon="mdi:magnify" fontSize={"30px"} />
          </IconButton>
          <Link href="/collection" aria-label="Flash sale">
            <IconButton sx={QUICK_ACTION_SX}>
              <LocalFireDepartmentIcon sx={{ color: "#F25F4C", fontSize: 22 }} />
            </IconButton>
          </Link>
          <Link href="/collection" aria-label="Khuyến mãi">
            <IconButton sx={QUICK_ACTION_SX}>
              <Image src={"/assets/icons/gift.svg"} alt={"gift-button"} width="22" height="22" />
            </IconButton>
          </Link>
          <Box
            sx={{
              "& > button": {
                width: 42,
                height: 42,
                minWidth: 42,
                borderRadius: 2,
                p: 0,
              },
            }}
          >
            <CartButtonWithSwipeableDrawer
              cartUrl={props.cartUrl}
              checkoutUrl={props.checkoutUrl}
              productUrlPrefix={props.productUrlPrefix}
            />
          </Box>
        </FlexBox>
      </FlexBetween>

      {/* SEARCH FORM DRAWER */}
      <Drawer
        open={searchBarOpen}
        anchor="top"
        onClose={toggleSearchBar}
        sx={{
          zIndex: 9999,
        }}
      >
        <Box
          sx={{
            width: "100%",
            boxSizing: "border-box",
            px: 2,
            py: 2,
            height: "100vh",
          }}
        >
          <FlexBetween mb={1}>
            <Paragraph>
              <SalifyFallback.Label path="Browse products" default="Tìm kiếm sản phẩm" />
            </Paragraph>

            <IconButton onClick={toggleSearchBar}>
              <IconDefault icon="mdi:close" />
            </IconButton>
          </FlexBetween>

          {/* CATEGORY BASED SEARCH FORM — overflow visible so absolute SearchResult dropdown is not clipped */}
          <Box sx={{ width: "100%", overflow: "visible", position: "relative", zIndex: 1 }}>
            <SearchInput searchCallback={toggleSearchBar} />
          </Box>
        </Box>
      </Drawer>
    </>
  );
};

export default MobileHeader;
